var exports = {
  "x9": "YouTubePlayer__YlUGj0",
  "vL": "Iframe__JF7QGN",
  "hJ": "Overlay__Xc3cdu",
  "nT": "PosterImage__nrNK--",
  "DM": "PlayButton__nyWukC",
  "sY": "PlayButtonIcon__bzSAvr",
  "hs": "PosterImage-anim__coO56l",
};

module.exports = exports;
